import { Theme } from '../index.d';
import UI_THEME_DEFAULT from './UI_THEME_DEFAULT';

const UI_THEME_MERITO: Theme = {
  pallete: {
    ...UI_THEME_DEFAULT.pallete,
    secondary: '#37B34a',
    'alternative-secondary': '#2D983E',
    'alternative-secondary-light': '#4DBF5E',
    'secondary-light': '#A8DFB0',
    'secondary-lighter': '#E3F5E6',
    main: '#000000',
    'alternative-main': '#0D1117',
    'main-light': '#454A54',
    'main-alternative-light': '#5C6472',
    'main-lighter': '#9FA8B5',
    'main-alternative-lighter': '#EBECEF',

    logo: 'url("/assets/merito/logo.svg")',
    'logo-horizontal': 'url("/assets/merito/logo.svg")',
    'login-background': 'url("/assets/merito/login-background.svg")',
  },
  brand: {
    ...UI_THEME_DEFAULT.brand,
    name: 'Mérito',
    company_name: 'Mérito Investimentos',
    company_cnpj: '15.632.652/0001-16',
    desc: 'Módulo de cadastro',
    prefix: 'merito',
    footerText: `Mérito - Todos os direitos reservados ${new Date().getFullYear()}`,
    logoText: 'Mérito',
    logoWidth: 50,
    minWidth: 50,
    logo: '/assets/merito/logo.svg',
    logoHorizontal: '/assets/merito/logo.svg',
    favicon: '/assets/favicon/merito-favicon.ico',
    simplifiedFund: false,
  },
  api: {
    ...UI_THEME_DEFAULT.api,
    local: 'https://api.data.merito.prosperita.io',
    dev: 'https://api.data.merito.prosperita.io',
    stage: 'https://api.data.merito.prosperita.io',
    prod: 'https://api.data.merito.prosperita.io',
    clarity_id: 'fhco559uuk',
    sentry_dsn:
      'https://561c977b8b3148de9e15e4e241b2e6ca@sentry.tools.prosperita.io/25',
  },
};

export default UI_THEME_MERITO;
